"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.range = range;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

function* range(start, end, step = 1) {
  for (let i = start; step > 0 ? i < end : i > end; i += step) {
    yield i;
  }
}

var _default = (0, _iterable.wrapWithMethodIterable)(range, {
  validateArgs(args) {
    let [optsOrEndOrStart, end = Infinity, step = 1] = args;
    let start = 0;

    if (typeof optsOrEndOrStart === 'number') {
      if (args.length > 1) {
        start = optsOrEndOrStart;
      } else {
        end = optsOrEndOrStart;
      }
    } else if (optsOrEndOrStart && typeof optsOrEndOrStart === 'object') {
      ({
        start = 0,
        end = Infinity,
        step = 1
      } = optsOrEndOrStart);
    }

    if (typeof start !== 'number') {
      throw new TypeError('The specified start was not a number');
    }

    if (typeof end !== 'number') {
      throw new TypeError('The specified end was not a number');
    }

    if (typeof step !== 'number' || step === 0) {
      throw new TypeError('The specified step was not a number !== 0');
    }

    args[0] = start;
    args[1] = end;
    args[2] = step;
  }

});

exports.default = _default;